import { FlexColumn, FlexRow, LabeledData, MaterialIcon, useModal, useMoment } from '@gorila-shared-ui/components';
import { Button } from 'baseui/button';
import { HeadingXSmall, ParagraphMedium } from 'baseui/typography';
import { useRecoilValue } from 'recoil';
import { useStyles } from '../../hooks/useStyles';
import { notificationTypesState } from '../../storage/notifications';
import { Notification } from '../../types/notification';
import { getAssetTitle } from '../../utils/assets';
import AssetModal from '../assets/modal/AssetModal';
import { StyledTooltip } from '../ui/StyledTooltip';

type Props = Readonly<{
  notification?: Notification;
  endActions?: React.ReactNode;
  startActions?: React.ReactNode;
}>;

export function NotificationInfo({ notification, endActions, startActions }: Props) {
  const { theme, classes, css } = useStyles();
  const { formatDateFromTs } = useMoment();
  const notificationTypes = useRecoilValue(notificationTypesState);
  const { closeModal: closeAssetModal, openModal: openAssetModal, showModal: showAssetModal } = useModal();

  if (!notification) return null;

  const notificationType = (() => {
    return (
      notificationTypes?.find((notificationType) => notificationType.notificationId === notification.notificationType)
        ?.name ?? notification.notificationType.toString()
    );
  })();

  return (
    <FlexColumn>
      <FlexColumn gap={theme.sizing.scale100}>
        <FlexRow
          classNames={css({
            alignItems: 'center',
            justifyContent: 'space-between',
          })}
        >
          {notification.asset && (
            <FlexRow
              gap={theme.sizing.scale200}
              classNames={classes.centeredStart}
            >
              <HeadingXSmall margin={0}>{getAssetTitle(notification.asset)}</HeadingXSmall>
              <ParagraphMedium
                margin={0}
                color={theme.colors.contentSecondary}
              >
                ({notification.asset.label})
              </ParagraphMedium>
            </FlexRow>
          )}
          <FlexRow gap={theme.sizing.scale200}>
            {startActions}
            {notification.asset && (
              <StyledTooltip
                content="Información del activo"
                showArrow={false}
              >
                <Button
                  shape="circle"
                  kind="tertiary"
                  size="compact"
                  onClick={openAssetModal}
                >
                  <MaterialIcon
                    name="info"
                    size="mini"
                  />
                </Button>
              </StyledTooltip>
            )}
            {endActions}
          </FlexRow>
        </FlexRow>
      </FlexColumn>
      <FlexColumn gap={theme.sizing.scale200}>
        <LabeledData
          label="Notificación:"
          content={notification.title}
          labelWidth="100px"
        />
        <LabeledData
          label="Tipo:"
          content={notificationType}
          labelWidth="100px"
        />
        <LabeledData
          label="Fecha:"
          content={notification.timestamp ? formatDateFromTs(+new Date(notification.timestamp)) : '-'}
          labelWidth="100px"
        />
        <LabeledData
          label="Latitud:"
          content={notification.latitude?.toString() ?? '-'}
          labelWidth="100px"
        />
        <LabeledData
          label="Longitud:"
          content={notification.longitude?.toString() ?? '-'}
          labelWidth="100px"
        />
      </FlexColumn>
      {notification.asset && (
        <AssetModal
          onClose={closeAssetModal}
          isOpen={showAssetModal}
          assetId={notification.asset._id}
          assetData={notification.asset}
        />
      )}
    </FlexColumn>
  );
}
